import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './LandingPage.css';

const LandingPage = () => {
  const { isAuthenticated, login } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showDemoInfo, setShowDemoInfo] = useState(true);

  // Если пользователь уже залогинен, перенаправляем на дашборд
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.message || 'Ошибка входа');
    } finally {
      setLoading(false);
    }
  };

  // Прокрутка к форме (для кнопок "Начать" и "Посмотреть демо")
  const scrollToForm = () => {
    const formEl = document.getElementById('login-form-container');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  // Эффекты для анимаций (из оригинального скрипта)
  useEffect(() => {
    // Header scroll effect
    const header = document.querySelector('.header');
    const handleScroll = () => {
      if (window.scrollY > 50) {
        header?.classList.add('scrolled');
      } else {
        header?.classList.remove('scrolled');
      }
    };
    window.addEventListener('scroll', handleScroll);

    // Fade-up animation
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll('.fade-up').forEach((el) => observer.observe(el));

    // Popups animation
    const popupObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const popups = entry.target.querySelectorAll('.popup');
            popups.forEach((popup, i) => {
              setTimeout(() => {
                popup.classList.add('visible');
              }, parseInt(popup.dataset.delay) || i * 200);
            });
          }
        });
      },
      { threshold: 0.2 }
    );
    const howWrapper = document.querySelector('.how-image-wrapper');
    if (howWrapper) popupObserver.observe(howWrapper);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      observer.disconnect();
      popupObserver.disconnect();
    };
  }, []);

  return (
    <div className="landing-page">
      {/* HEADER */}
      <header className="header" id="header">
        <div className="header-inner">
          <a href="#hero" className="logo">
            <img src="https://eosmon.ru/EosLogo.png" width="322" alt="EosMonitor" />
          </a>

          <nav className="navInner" style={{background: 'none'}}>
            <a href="#about">О сервисе</a>
            <a href="#how">Как работает</a>
            <a href="#clients">Клиенты</a>
            <a href="#pricing">Тарифы</a>
          </nav>

          <div className="header-contacts">
            <a href="tel:+79832149932">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
              </svg>
              +7 983 214-99-32
            </a>
            <a href="mailto:info@eosmon.ru">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
              info@eosmon.ru
            </a>
          </div>

          <button className="mobile-toggle" onClick={() => document.getElementById('mobileMenu').classList.toggle('active')}>
            <span></span><span></span><span></span>
          </button>
        </div>

        <div className="mobile-menu" id="mobileMenu">
          <a href="#about" onClick={() => document.getElementById('mobileMenu').classList.remove('active')}>О сервисе</a>
          <a href="#how" onClick={() => document.getElementById('mobileMenu').classList.remove('active')}>Как работает</a>
          <a href="#clients" onClick={() => document.getElementById('mobileMenu').classList.remove('active')}>Клиенты</a>
          <a href="#pricing" onClick={() => document.getElementById('mobileMenu').classList.remove('active')}>Тарифы</a>
          <div className="mobile-contact">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
            </svg>
            +7 983 214-99-32
          </div>
          <div className="mobile-contact">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
              <polyline points="22,6 12,13 2,6" />
            </svg>
            info@eosmon.ru
          </div>
        </div>
      </header>

      {/* HERO */}
      <section className="hero" id="hero">
        <div className="hero-bg">
          <img src="https://eosmon.ru/bgScreen1.png" alt="Dashboard" />
        </div>
        <div className="hero-overlay"></div>

        <div className="hero-content">
          <div className="hero-info fade-up">
            <div className="hero-badge">
              <span className="dot"></span>
              Система работает 24/7
            </div>
            <h1>Мониторинг&nbsp;<span className="accent">в реальном времени</span></h1>
            <p>ЭосМониторинг — облачная платформа для мониторинга показаний с датчика температуры, влажности, освещенности полученных через навигационный терминал. Отслеживайте всё, что важно для вашего бизнеса.</p>

            <div className="hero-stats">
              <div className="pricing-popular" style={{ textTransform: 'none !important' }}>
                Для демо доступа используйте:<br />
                Email demo@eosmon.ru и Пароль demo321
              </div>
            </div>

            <div className="hero-stats">
              <div className="hero-stat">
                <div className="hero-stat-value">2</div>
                <div className="hero-stat-label">Объекта мониторинга</div>
              </div>
              <div className="hero-stat">
                <div className="hero-stat-value">10</div>
                <div className="hero-stat-label">Датчиков онлайн</div>
              </div>
              <div className="hero-stat">
                <div className="hero-stat-value">99.9%</div>
                <div className="hero-stat-label">Доступность данных</div>
              </div>
            </div>
          </div>

          <div className="login-card fade-up" id="login-form-container">
            <h2>Вход в систему</h2>
            <div className="subtitle">Введите свои учётные данные</div>

            {error && <div className="auth-error">{error}</div>}

            <form onSubmit={handleLogin} className="login-form-wrapper">
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="your@email.com"
                />
              </div>
              <div className="form-group">
                <label>Пароль</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="••••••••"
                />
              </div>
              <div className="form-options">
                <label>
                  <input type="checkbox" /> Запомнить меня
                </label>
                <Link to="/forgot-password">Забыли пароль?</Link>
              </div>
              <button type="submit" className="btn-primary" disabled={loading}>
                {loading ? 'Вход...' : 'Войти в систему'}
              </button>
              <div className="login-footer">
                Нет аккаунта? <Link to="/register">Зарегистрироваться</Link>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* ABOUT */}
      <section className="section about" id="about">
        <div className="section-inner">
          <div className="section-label fade-up">О сервисе</div>
          <h2 className="section-title fade-up">Всё, что нужно для контроля</h2>
          <p className="section-desc fade-up">Инструменты, которые работают на вас.</p>

          <div className="about-grid">
            <div className="about-text fade-up">
              <div className="features-grid" id="features">
                <div className="feature-card">
                  <div className="feature-item">
                    <div className="icon"><i className="fas fa-chart-pie"></i></div>
                    <h4>Гибкая визуализация</h4>
                    <p>Текст, шкалы — выбирайте удобный способ отображения для каждого датчика.</p>
                  </div>
                </div>
                <div className="feature-card">
                  <div className="feature-item">
                    <div className="icon"><i className="fas fa-chart-line"></i></div>
                    <h4>График за 24 часа</h4>
                    <p>Детальный анализ изменения температуры с возможностью просмотра пиковых значений.</p>
                  </div>
                </div>
                <div className="feature-card">
                  <div className="feature-item">
                    <div className="icon"><i className="fas fa-exclamation-triangle"></i></div>
                    <h4>Визуальные триггеры</h4>
                    <p>Задавайте пороги — выход за границы подсветит карточку и привлечёт внимание.</p>
                  </div>
                </div>
                <div className="feature-card">
                  <div className="feature-item">
                    <div className="icon"><i className="fas fa-calculator"></i></div>
                    <h4>Конвертация данных</h4>
                    <p>Применяйте собственные таблицы пересчёта для любых единиц измерения.</p>
                  </div>
                </div>
                <div className="feature-card">
                  <div className="feature-item">
                    <div className="icon"><i className="fas fa-cog"></i></div>
                    <h4>Светлая и тёмная тема</h4>
                    <p>Переключайтесь между светлой и тёмной темой оформления. Работайте комфортно в любое время суток.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="about-visual fade-up">
              <div className="about-visual-cardLight">
                <h3>Светлая тема</h3>
                <img src="https://eosmon.ru/bgScreen1.png" width="600" style={{ borderRadius: '5px', marginTop: '15px' }} alt="светлая тема" />
              </div>
              <div className="about-visual-cardDark" style={{ marginTop: '40px' }}>
                <h3>Темная тема</h3>
                <img src="https://eosmon.ru/DBdark.png" width="600" style={{ borderRadius: '5px', marginTop: '15px' }} alt="тёмная тема" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="section how-it-works" id="how">
        <div className="section-inner">
          <div className="section-label fade-up">Как это работает</div>
          <h2 className="section-title fade-up">Три простых шага к мониторингу</h2>
          <p className="section-desc fade-up">Начните отслеживать показания датчиков за несколько минут</p>

          <div className="steps-container" style={{ marginTop: '35px' }}>
            <div className="step">
              <div className="step-number">1</div>
              <h3>Регистрация</h3>
              <p>Создайте аккаунт в системе ЭосМониторинг или посмотрите демо-доступ для ознакомления с функционалом.</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>Подключение</h3>
              <p>Подключите навигационный контроллер с датчиками температуры, влажности и освещённости к системе.</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>Мониторинг</h3>
              <p>Настройте дашборд, задайте пороги и приглашайте команду. Получайте показания в реальном времени.</p>
            </div>
          </div>

          <div className="how-image-wrapper fade-up">
            <img src="https://eosmon.ru/show1.png" alt="How it works" />

            <div className="popup popup-1" data-delay="0">
              <h4>Сервер</h4>
              <p>Масштабируемое хранилище в облаке</p>
            </div>
            <div className="popup popup-2" data-delay="200">
              <h4>Мониторинг</h4>
              <p>Вывод информации хоть на телефон, экран или телевизор</p>
            </div>
            <div className="popup popup-3" data-delay="400">
              <h4>Транспорт</h4>
              <p>Термобудки, рефрижераторы, прицепы с климатическими установками</p>
            </div>
            <div className="popup popup-4" data-delay="600">
              <h4>Недвижимость</h4>
              <p>Склады, морозильные камеры, производственные помещения, теплицы</p>
            </div>
          </div>
        </div>
      </section>

      {/* CLIENTS */}
      <section className="section clients" id="clients">
        <div className="section-inner">
          <div className="section-label fade-up">Нам доверяют</div>
          <h2 className="section-title fade-up">Компании, которые уже<br />используют ЭосМониторинг</h2>
          <p className="section-desc fade-up">Компании получили доступ к сервису и участвуют в его тестировании и развитии функционала.</p>

          <div className="clients-grid fade-up" style={{ marginTop: '25px' }}>
            Будьте одним из первых, кто попробует сервис
          </div>
        </div>
      </section>

      {/* PRICING */}
      <section className="section pricing" id="pricing">
        <div className="section-inner">
          <div className="section-label fade-up">Тарифы</div>
          <h2 className="section-title fade-up">Простой и прозрачный тариф</h2>
          <p className="section-desc fade-up">Один тариф — все возможности. Платите только за объекты мониторинга.</p>

          <div className="pricing-card fade-up" style={{ marginTop: '40px' }}>
            <div className="pricing-name">Стандарт</div>
            <div className="pricing-desc">Датчики — безлимитно на каждом объекте.</div>
            <div className="pricing-price">
              <span className="pricing-amount">от 500</span>
              <span className="pricing-currency">₽</span>
              <span className="pricing-period">/ за объект в месяц</span>
            </div>
            <ul className="pricing-features">
              <li><span className="check">✓</span> Хранение данных 90 дней</li>
              <li><span className="check">✓</span> Неограниченное количество пользователей</li>
              <li><span className="check">✓</span> Все функции платформы</li>
            </ul>
            <button className="btn-pricing" onClick={scrollToForm}>Начать бесплатный период</button>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section cta" id="cta">
        <div className="section-inner cta-content">
          <h2 className="fade-up">Готовы начать?</h2>
          <p className="fade-up">Присоединяйтесь к компаниям, которые уже контролируют свои объекты с ЭосМониторинг.</p>
          <button className="btn-cta fade-up" onClick={scrollToForm}>
            Посмотреть демо
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <div className="footer-inner">
          <div className="footer-logo">
            {/* <img src="/EosLogo.png" width="322" /> */}
          </div>
          <div className="footer-links">
            <a href="https://eosmon.ru/publichnaya-oferta.html">Публичная оферта</a>
          </div>
          <div className="footer-copy">© 2026 К.В. Пинчин. Все права защищены.</div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;